// dependencies
import React, { useState, useImperativeHandle } from "react";
// eslint-disable-next-line react/no-deprecated
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import { IntlProvider } from "react-intl";

// contexts
import { RequestContextProvider } from "@cloudspire/legacy-resources/src/contexts/requestContext";
import { AuthProvider } from "@cloudspire/legacy-resources/src/contexts/AuthContext";

// components
import Modal from "@cloudspire/legacy-resources/src/components/Modal";

// constants
import theming from "@cloudspire/legacy-resources/src/constants/theming";

const { ThemeProvider } = theming;

const ModalHandler = React.forwardRef<any, any>(function ModalHandler(
  props,
  ref
) {
  const [opened, setOpened] = useState(true);

  const { children, onShouldClose, onHide } = props;

  useImperativeHandle(ref, () => ({
    close: () => setOpened(false),
  }));

  return (
    <Modal opened={opened} onHide={onHide} onShouldClose={onShouldClose}>
      {children(onShouldClose)}
    </Modal>
  );
});

const createModal = ({ children, intl, theme, configuration, auth }) => {
  const $modal = document.createElement("div");
  const $body = document.querySelector("#custom-modal");

  const $nodes = {
    modalHandler: React.createRef(),
  };

  const handleHide = () => {
    unmountComponentAtNode($modal);
    $body.removeChild($modal);
  };

  const handleShouldClose = () => {
    ($nodes.modalHandler.current as any).close();
  };

  $body.appendChild($modal);

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <IntlProvider messages={intl.messages} locale={intl.locale}>
        <AuthProvider domain={auth.domain}>
          <RequestContextProvider
            requestContext={{
              channelId: configuration.channel.id,
            }}
          >
            <ModalHandler
              ref={$nodes.modalHandler}
              onHide={handleHide}
              onShouldClose={handleShouldClose}
            >
              {children}
            </ModalHandler>
          </RequestContextProvider>
        </AuthProvider>
      </IntlProvider>
    </ThemeProvider>,
    $modal
  );
};

export default createModal;
